<template>
<!--
<div class="close-btn">
  <i class="icon-angle-down"></i>  
</div> 
-->
<transition name="slide">
  <div class="sticky-footer">
    <form id="conuselForm" class="absolute-footer" v-on:submit.prevent="onSubmit" method="post">
      <div class="container p-2">
        <div class="row">
          <div class="col-8">
            <div class="container">
              <!-- <div class="row">
                <div class="col-auto">                
                  <i class="icon-angle-down"></i>
                </div>
              </div>   -->
              <div class="row">
                <div class="col p-1">
                  <input
                    v-model="CLIENT_NAME"
                    class="form-control form-control-sm"
                    type="text"
                    :placeholder= "$t('name')"
                    maxlength="24"
                  />
                </div>
                <div class="col p-1">
                  <input
                    v-model.number="CLIENT_HP"
                    class="form-control form-control-sm"
                    type="number"
                    :placeholder= "$t('contact')"
                    maxlength="20"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col p-1">
                  <select
                    id="inputState"
                    class="form-control form-control-sm custom-select-sm"
                    v-model="COUNSEL_INTEREST"
                  >
                    <option :value="null" disabled>-{{ $t('interest') }}-</option>
                    <option value="M자">{{ $t('hairshapem') }}</option>
                    <option value="정수리">{{ $t('hairshapecrown') }}</option>
                    <option value="헤어라인">{{ $t('hairshapeline') }}</option>
                    <option value="원형탈모">{{ $t('hairshapecircle') }}</option>
                    <option value="흉터이식">{{ $t('hairshapescar') }}</option>
                    <option value="리얼모델">{{ $t('hairshaperealmodel') }}</option>
                    <option value="기타">{{ $t('hairshapeetc') }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 p-0">
            <div class="container p-0">
              <div class="row">
                <div class="col p-0">
                  <!-- <a
                    href="#"
                    @click="submitForm"
                    class="button button-3d button-small button-rounded button-blue pl-2 pr-1"
                    >빠른상담
                    <i class="icon-circle-arrow-right p-0 m-0"></i>
                  </a> -->
                  <!-- <button
                    type="submit"
                    class="button button-3d button-small button-rounded button-blue pl-2 pr-1"
                  > -->
                  <button
                    type="submit"
                    class="button form-control-sm custom-btn"
                  >
                    {{ $t('quickcounsel') }}
                    <i class="icon-circle-arrow-right p-0 m-0"></i> 
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col p-0">
                  <div v-if=isKoLocale() class="form-group form-check m-1">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="exampleCheck1"
                      v-model="agreed"
                    />
                    <label
                      class="form-check-label text-light small"
                      for="exampleCheck1"
                      style="font-size: 8px;">
                      {{ $t('privacyagree') }}</label>
                    <a @click="showUserAgreemnet">
                      <span class="small" style="font-size: 8px;">[{{ $t('showdetail') }}]</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <modal name="user-agreement" :width="350" :height="430">
      <div class="agreement-container">
        <user-agreement @close="hideUserAgreemnet" />
      </div>
    </modal>
  <img v-if=isZhLocale() class="wechat-btn" src = "https://forhairweb.cdn3.cafe24.com/zh/wechat-min-200.jpg" >
  </div>
</transition>
</template>

<script>
import UserAgreement from "./popup/UserAgreement.vue";
import { isMobile } from "mobile-device-detect";

const qs = require("qs");

export default {
  name: "MobileStickyForm",
  components: {
    UserAgreement
  },
  data() {
    return {
      errors: [],
      CLIENT_NAME: "",
      CLIENT_HP: "",
      COUNSEL_INTEREST: null,
      agreed: false,
      response: "",
    };
  },
  methods: {
    isKoLocale(){
      return !this.$i18n.locale  || this.$i18n.locale == 'ko';
    },
    isZhLocale(){
      return this.$i18n.locale === 'zh';
    },
    clearForm(){
      this.CLIENT_NAME = "";
      this.CLIENT_HP = "";
      this.COUNSEL_INTEREST = null;
      this.agreed = false;
      this.errors = [];
    },
  
    onSubmit() {

      var submitLocale = !this.$i18n.locale ? 'ko' : this.$i18n.locale;

      if(submitLocale != 'ko') this.agreed = true

      if (
        this.CLIENT_NAME &&
        this.CLIENT_HP &&
        this.COUNSEL_INTEREST &&
        this.agreed
      ) {
        var params = qs.stringify({
          COUNSEL_GUBUN: '19LANDING[' + submitLocale + ']',
          COUNSEL_PATH: isMobile ? 'MOBILE' : 'PC',
          CLIENT_NAME: this.CLIENT_NAME,
          CLIENT_HP: this.CLIENT_HP,
          COUNSEL_INTEREST: this.COUNSEL_INTEREST,
        });

        var that = this;

        this.$http
        .post("https://www.forhair.co.kr/cs/cost_thankyou_ajax.asp", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(res) {
          if(res.data.result === "success"){
            that.$swal({
              animation: false,
              customClass: "animated fadeIn",
              text: that.$t('counselregistered'),
              confirmButtonText: that.$t('confirm')
            });
            that.clearForm();
          }
        })
        .catch(function(error) {
          that.$swal({
              animation: false,
              customClass: "animated fadeIn",
              text: that.$t('error') + '[' + error + ']',
              confirmButtonText: that.$t('confirm')
            });
        });
      
      return;
      
      }
      this.errors = [];

      if (!this.CLIENT_NAME) {
        this.errors.push(this.$t('inputerror1', {msg: this.$t('name')}));
      }

      if (this.CLIENT_HP.length < 8) {
        this.errors.push(this.$t('inputerror1', {msg:this.$t('right') + ' ' +  this.$t('contact')}));
        // this.errors.push("올바른 <b>전화번호</b>를 입력해 주세요.");
      }

      if (!this.COUNSEL_INTEREST) {
        this.errors.push(this.$t('inputerror2', {msg: this.$t('interest')}));
        // this.errors.push("<b>관심부위</b>를 선택해 주세요.");
      }

      if (!this.agreed && this.isKoLocale()) {
        this.errors.push(this.$t('privacyagreeerror'));
        // this.errors.push("개인정보수집에 동의해 주세요.");
      }
      this.$swal({
        animation: false,
        customClass: "animated fadeIn",
        html: this.errors.join("<br/>"),
        confirmButtonText: this.$t('confirm')
      });

    },
    showUserAgreemnet() {
      this.$modal.show("user-agreement");
    },
    hideUserAgreemnet() {
      this.$modal.hide("user-agreement");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.custom-btn{ width: 80%; }
.absolute-footer {
  background: rgba(5, 5, 5, 0.65);
  position: fixed;
  bottom: 0px;
  box-sizing: border-box;
  color: #fff;
  left: 0;
  padding: 0px 0;

  font-size: 16px;
  width: 100%;
  z-index: 99990;
  float: left;
  vertical-align: middle;
  margin: 0px 0 0;
}

.wechat-btn {
  position: fixed;
  right: 1.3em;
  width: 5em;
  bottom: 8em;
  z-index: 99998;
  float: right;
} 

.form-control:focus {
  border-color: #1900ff;
  box-shadow: 0 0 0 0.2rem rgba(0, 60, 255, 0.5);
}

.agreement-container {
  overflow: auto;
  height: 430px;
}

.slide-enter-active, .slide-leave-active {
  transition: margin-bottom .8s ease-out;
}

.slide-enter, .slide-leave-to {
  margin-bottom: -200px;
}

.slide-enter-to, .slide-leave {
  margin-bottom: 0px;
}

</style>
